import React from "react";
import {domain} from '../../Auth/Config'
const gameIframeUrl = domain + '/wp-json/freespin/v1/game';
export {gameIframeUrl};